import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/mian.less";
import "./assets/css/bts.less";
import "./assets/font/iconfont";
import "./assets/font/iconfont.css";
import "./assets/font/ali_iconfont.css";
import echart from "echarts";
import VDistpicker from "v-distpicker";
import "vue-orgchart/dist/style.min.css";
//单个图片上传
import ImgBigUpload from "@/components/ImgBigUpload";
import _ from "lodash"; //引用loadsh
// element 弹窗封装
import modal from '@/utils/modal.js'
// 获取全路径
import { getSeverFileUrl } from "@/utils/tool.js";
//全局引入dayjs
import dayjs from "dayjs";
//搜索框
import MySearchInput from "@/components/MySearchInput";
Vue.component("MySearchInput", MySearchInput);

Vue.use(ElementUI);
Vue.component("ImgBigUpload", ImgBigUpload);

Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false;
Vue.prototype.$echarts = echart;
Vue.prototype.$modal = modal;
Vue.prototype.getSeverFileUrl = getSeverFileUrl;
//loadsh
Vue.prototype._ = _;
//全局插件加载dayjs
Vue.prototype.$dayjs = dayjs;

Vue.component("v-distpicker", VDistpicker);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
